var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargeTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.168,
    height: 179.962,
    viewBox: "0 0 158.168 179.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bin",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2616",
    "data-name": "Group 2616",
    transform: "translate(10.968 52.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2615",
    "data-name": "Group 2615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M62.205,150l9.339,112.735a15.9,15.9,0,0,0,15.755,14.5h86.045a15.9,15.9,0,0,0,15.755-14.5L198.437,150Zm41.75,106.15a5.272,5.272,0,0,1-5.257-4.943l-5.272-85.06a5.272,5.272,0,0,1,4.932-5.592,5.191,5.191,0,0,1,5.591,4.932l5.272,85.06A5.274,5.274,0,0,1,103.955,256.15Zm31.639-5.272a5.272,5.272,0,1,1-10.544,0v-85.06a5.272,5.272,0,1,1,10.544,0Zm31.623-84.73-5.272,85.06a5.272,5.272,0,0,1-10.524-.659l5.272-85.06a5.358,5.358,0,0,1,5.591-4.932A5.272,5.272,0,0,1,167.216,166.147Z",
    transform: "translate(-62.205 -150)",
    fill: "#00ab79"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2618",
    "data-name": "Group 2618",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2617",
    "data-name": "Group 2617",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M178.623,21.089H146.99V15.817A15.834,15.834,0,0,0,131.173,0H88.995A15.834,15.834,0,0,0,73.178,15.817v5.272H41.545a10.545,10.545,0,0,0,0,21.089H178.623a10.545,10.545,0,0,0,0-21.089Zm-42.178,0H83.723V15.817a5.276,5.276,0,0,1,5.272-5.272h42.178a5.276,5.276,0,0,1,5.272,5.272Z",
    transform: "translate(-31)",
    fill: "#00ab79"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeTrash);
export default __webpack_public_path__ + "static/media/large-trash.2d5b4f9a670a4b1816e382c7d13f0860.svg";
export { ForwardRef as ReactComponent };